import React from "react";

import { mapNewsToLadySlider } from "@/features/newsfeed/helpers";
import { NewsfeedToggleMediaFavorite } from "@/features/newsfeed/hooks";

import { LadySliderModalBottomButtonsPropTypes } from "../components/bottom-buttons";
import { SliderContextProvider } from "../context/Slider.context";
import { NewsfeedSlider } from "./NewsfeedSlider";

type PropTypes = {
  toggleMediaFavorite: NewsfeedToggleMediaFavorite;
  data: ReturnType<typeof mapNewsToLadySlider>;
  initialIndex: number;
  bottomButtonsProps: LadySliderModalBottomButtonsPropTypes;
  sectionInd: number;
};

export const NewsfeedSliderModal: React.FC<PropTypes> = ({
  toggleMediaFavorite,
  data,
  initialIndex,
  bottomButtonsProps,
  sectionInd,
}) => {
  return (
    <SliderContextProvider
      initialIndex={initialIndex}
      mediaLength={data.length}
    >
      <NewsfeedSlider
        toggleMediaFavorite={toggleMediaFavorite}
        data={data}
        bottomButtonsProps={bottomButtonsProps}
        sectionInd={sectionInd}
      />
    </SliderContextProvider>
  );
};
